"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.array.includes.js");
var _utils = require("../utils");
var _fixTop = _interopRequireDefault(require("../fix-top"));
var _popup = require("../mixins/popup");
var _iphoneX = require("../mixins/iphone-x");
var _use = (0, _utils.use)('popup'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  mixins: [_popup.PopupMixin, _iphoneX.iPhoneXMixin],
  props: {
    position: {
      type: String,
      default: 'center'
    },
    fixTop: Boolean,
    duration: String,
    transition: String,
    overlay: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    },
    className: String
  },
  computed: {
    transitionName: function transitionName() {
      var defaultName = ['left', 'top', 'right', 'bottom'].includes(this.position) ? "z-popup-slide-" + this.position : 'z-fade';
      return this.transition || defaultName;
    }
  },
  render: function render(h) {
    var _this = this,
      _bem;
    if (!this.shouldRender) {
      return;
    }
    var position = this.position,
      isiPhoneX = this.isiPhoneX,
      duration = this.duration;
    var emit = function emit(event) {
      return function () {
        return _this.$emit(event);
      };
    };
    return h("transition", {
      "attrs": {
        "name": this.transitionName
      },
      "on": {
        "afterEnter": emit('opened'),
        "afterLeave": emit('closed')
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.value
      }],
      "style": {
        transitionDuration: duration
      },
      "class": [bem((_bem = {}, _bem[position] = position, _bem)), position === 'bottom' && isiPhoneX ? 'z-iphone-x' : '', this.className]
    }, [this.fixTop && ['left', 'right'].includes(position) && h(_fixTop.default, {
      "attrs": {
        "keepPosition": true,
        "headerTaskbarBG": "transparent"
      }
    }), position === 'share' && h("img", {
      "attrs": {
        "src": "https://pic6.zhuanstatic.com/zhuanzh/n_v20f25b49aef104bb99957a6b8fc1819aa.png"
      }
    }), position !== 'overlay' && this.slots()])]);
  }
});
exports.default = _default;